import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Try multiple scroll methods with a small delay
    const scrollToTop = () => {
      // Method 1: scrollTo
      window.scrollTo(0, 0);

      // Method 2: scrollIntoView
      document.documentElement.scrollIntoView({ behavior: "instant" });

      // Method 3: set scrollTop directly
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Execute immediately
    scrollToTop();

    // And again after a tiny delay to ensure it works
    setTimeout(scrollToTop, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
